import { Pipe, PipeTransform } from '@angular/core';
import { AppointmentRequestConsultingType } from '@warema/shared/models';

@Pipe({
    name: 'appointmentConsultingTypePipe',
})
export class AppointmentConsultingTypePipe implements PipeTransform {
    public transform(consultingType: AppointmentRequestConsultingType): string {
        switch (consultingType) {
            case AppointmentRequestConsultingType.Measurement:
                return 'MEASUREMENT';

            case AppointmentRequestConsultingType.Product:
                return 'PRODUCT';

            case AppointmentRequestConsultingType.PriceInformation:
                return 'PRICE_INFORMATION';

            case AppointmentRequestConsultingType.DesignOrColor:
                return 'DESIGN_COLOR';

            case AppointmentRequestConsultingType.Technical:
                return 'TECHNICAL';

            default:
                return 'UNKNOWN';
        }
    }
}
